import type { FaireProductEntity } from "../../entity_types/product";

export const p_1iwwgumo17: FaireProductEntity = {
  token: "p_1iwwgumo17",
  type: "product",
  name: "Mod Meow | Women's Novelty Cat Crew Socks",
  brandToken: "b_ca2nclcids",
  brandName: "Oooh Yeah/Sock It Up/Oooh Geez Slippers",
  imageUrl:
    "https://cdn.faire.com/fastly/1ecddd0842777e2699281f0688604c58c46e0d6da631bd4857a74b7cd27e79a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3ebe27fe853dedcec0b624be925835595f543719048737eb02ac31e44126530.jpeg",
    "https://cdn.faire.com/fastly/91d81b331d1cb8fb6542ba45616fbd4d51793b06802e4ae478e7ae1df0f6f120.jpeg",
  ],
  priceDollars: 4.75,
  description:
    "Novelty cat theme gift for cat lover.\nUS Size: Women's shoe size 5-10. One size fits most women.\nMade from premium cotton, these novelty socks are super soft and lightweight, allowing your feet to breathe and stay cool during strenuous activity.\nNot too tight and hold up well, fine toe seam reduces rubbing and gives extra comfort.\nSee Details tab for more info.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:31.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
